import React, { useContext, useMemo, useRef } from 'react'
import { SuggestedSearchContainer, ButtonsContainer, Button } from './styles'
import { Box, Carousel, type CarouselOptions, CarouselSlide, Typography } from '@hermes/web-components'
import SearchProfileCardMobileForced from '../SearchResults/SearchProfileCardMobileForced'
import { PracticeProfile, SpecialistProfile } from 'types'
import useTranslateMessage from '../../../../hooks/useTranslateMessage'
import { SearchProfilesPageContext } from '../../../../providers/SearchProfilesPage'
import '@splidejs/react-splide/css'

const gapBetweenSliders = '8px'

const SPLIDE_OPTIONS = {
  autoWidth: false,
  drag: 'free',
  lazyLoad: true,
  gap: gapBetweenSliders,
  pagination: false,
  perMove: 1,
  perPage: 3,
  arrows: false,
  breakpoints: {
    1400: {
      perPage: 3
    },
    1056: {
      perPage: 2
    },
    640: {
      perPage: 1,
      pagination: true
    }
  }
} as CarouselOptions

const SuggestedSearch = ({
  profilesToShow,
  handleSetVideoPlayerModalData,
  translatedName,
  currentSearchSpecialist
}: {
  profilesToShow?: (SpecialistProfile | PracticeProfile)[]
  handleSetVideoPlayerModalData: any
  translatedName?: string
  currentSearchSpecialist: any
}) => {
  const myCarouselRef = useRef<any>(null)
  const translate = useTranslateMessage()
  const {
    state: {
      filters: { location }
    }
  } = useContext(SearchProfilesPageContext)
  const handleNext = () => {
    myCarouselRef.current?.go('>')
  }

  const handlePrev = () => {
    myCarouselRef.current?.go('<')
  }

  const titleOfSection = useMemo(() => {
    return translate('search.suggested-search.title', {
      specialty: translatedName?.toLowerCase() || '',
      location: decodeURI(location)
    })
  }, [translatedName, location, translate])

  return (
    <SuggestedSearchContainer>
      <Typography variant="h2" fontWeight={500} fontFamily="Poppins" fontSize="15px">
        {titleOfSection}
      </Typography>
      <Box width="100%">
        <Carousel
          options={SPLIDE_OPTIONS}
          onRefReady={(ref) => {
            myCarouselRef.current = ref
          }}
        >
          {profilesToShow?.slice(0, 6).map((profile) => (
            <CarouselSlide
              key={`profile-card-${profile.id}`}
              sx={{
                minWidth: {
                  xl: `calc(33.4% - ${gapBetweenSliders})`,
                  lg: `calc(50% - ${gapBetweenSliders})`,
                  xs: '100%'
                }
              }}
            >
              <SearchProfileCardMobileForced
                {...(currentSearchSpecialist
                  ? { specialist: profile as SpecialistProfile }
                  : { practice: profile as PracticeProfile })}
                handleSetVideoPlayerModalData={handleSetVideoPlayerModalData}
                suggestedSearch
              />
            </CarouselSlide>
          ))}
        </Carousel>
      </Box>
      <ButtonsContainer>
        <Button onClick={handlePrev}>
          <img
            src="/hermes-static/icons/arrow-simple-right.svg"
            style={{
              transform: 'rotate(180deg)'
            }}
            alt="left"
          />
        </Button>
        <Button onClick={handleNext}>
          <img src="/hermes-static/icons/arrow-simple-right.svg" alt="right" />
        </Button>
      </ButtonsContainer>
    </SuggestedSearchContainer>
  )
}

export default SuggestedSearch
